<script setup lang="ts">

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useChangelogItemActions } from '../model/changelog-item-actions.hook'

defineOptions({
  name: 'ChangelogItemActions',
})

const emit = defineEmits<{
  'click:view': []
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  viewIcon,
  toggle,
  handleView,
} = useChangelogItemActions({
  onView: () => emit('click:view'),
})
</script>

<template>
  <div
    ref="containerRef"
    class="changelog-item-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      title="Changelog item actions"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="changelog-item-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="View detailed changelog"
          color="blue"
          :prepend-icon="viewIcon"
          @click="handleView"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./ChangelogItemActions.scss" />
